import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: async (userData) => {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },
  
  login: async (credentials) => {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },
  
  getMe: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
};

// Booking API
export const bookingAPI = {
  create: async (bookingData) => {
    const response = await apiClient.post('/bookings', bookingData);
    return response.data;
  },
  
  getAll: async () => {
    const response = await apiClient.get('/bookings');
    return response.data;
  },
};

// Chat API
export const chatAPI = {
  getMessages: async () => {
    const response = await apiClient.get('/chat/messages');
    return response.data;
  },
  
  sendMessage: async (message) => {
    const response = await apiClient.post('/chat/messages', { message });
    return response.data;
  },
};

// Photos API
export const photosAPI = {
  getAll: async () => {
    const response = await axios.get(`${BACKEND_URL}/api/photos`);
    return response.data;
  },
};

export default apiClient;
